// 日本語 (Japanese)
export default {

  // ロゴエリア
  logoArea_text_welcome: "ようこそ",
  logoArea_text_myBalance: "残高:",
  logoArea_btn_register: "登録",
  logoArea_btn_login: "ログイン",
  logoArea_btn_recharge: "チャージ",
  logoArea_btn_logout: "ログアウト",

  // 右上タイトルエリア
  headerArea_btn_exitChat_title: "チャットを閉じる",
  headerArea_btn_history_title: "履歴チャットを開く",
  headerArea_btn_save_title: "チャットを保存",

  // チャットエリア
  charArea_item_notSupportAudio: "ブラウザはオーディオ再生をサポートしていません",
  charArea_item_historyFileExpire: "履歴から生成されたファイルは期限切れです",

  // ファイルアップロードエリア
  uploadArea_btn_uploadFile_defaultText: "ファイルをアップロード",

  // コマンド入力エリア
  inputPanelArea_default_cmdRunFail: "実行失敗",
  inputPanelArea_cmdConfigNotFound: "コマンドが存在しません",
  inputPanelArea_cmdNotFound: "コマンドが見つかりません！",
  inputPanelArea_cmdNotNnderstand: "システムはあなたの意図を理解できませんでした。もう一度お試しください！",
  inputPanelArea_btn_text_send: "送信",
  inputPanelArea_btn_text_sending: "送信中",

  pleaseLoginAfterUse: "サービスを呼び出す前にログインしてください",
  registerSuccess: "ユーザー登録成功",
  serviceFail: "インターフェース要求失敗",
  loginExpired: "ログインが期限切れです。再度ログインしてください。",
  insufficientBalance: "残高不足です。チャージしてください。",

  // 確認ダイアログ
  confirmed_exitChat_title: "チャットを終了してもよろしいですか？",
  confirmed_exitChat_content: "チャットが進行中です。強制終了するとチャット履歴が失われます。最初に保存することをお勧めします。",
  confirm_overlapChat_title: "履歴チャット記録 [{{saveName}}] が既に存在します。上書きしてもよろしいですか？",
  confirm_overlapChat_content: "チャットが進行中です。強制終了するとチャット履歴が失われます。最初に保存することをお勧めします。",

  // ポップアップ
  pop_input_saveName_placeholder: "保存名を入力し、<Enter>キーを押して保存",

  // 一般ポップアップ
  modal_title_userLogin: "ユーザーログイン",
  modal_title_userRegister: "ユーザー登録",
  modal_title_newUser: "ようこそ！",
  modal_title_newRechange: "メンバーシップチャージ",
  nodal_content_newUser: "Dalipenはマルチメディア技術の発展に取り組む企業です。ここで 원하는 기능을 선택할 수 있습니다。始めるのに役立つように、100トークンを準備しました。",
  modal_btn_newUser: "始めましょう！",
  modal_btn_okText: "OK",
  modal_btn_cancelText: "キャンセル",
  modal_btn_loginText: "ログイン",
  modal_btn_rechange: "チャージ",
  modal_btn_getEmailCodeText: "メール確認コードを取得",
  modal_btn_registerText: "登録",
  modal_input_rechangeMoney_placeholder: "チャージ金額を入力してください",
  modal_form_email_label: "メール",
  modal_form_email_errorMsg: "メールを入力してください！",
  modal_form_password_label: "パスワード",
  modal_form_password_errorMsg: "パスワードを入力してください！",
  modal_form_code_label: "確認コード",
  modal_form_code_errorMsg: "確認コードを入力してください！",

  // メッセージ
  message_save_success: "保存成功",
  message_warn_isChatting: "チャットが進行中です。最初に保存することをお勧めします",
  message_error_rechange1: "チャージ金額を入力してください",
  message_error_rechange2: "正しい金額を入力してください。最小値は1です",

  // 支払い結果ページ
  pay_result_success: "支払い成功",
  pay_result_success_message: "ご購入ありがとうございます！",
  pay_result_fail: "支払い失敗",

  // メニューエリア
  menu_text: "テキスト",
  menu_text_10001: "SellMeThisPen",
  menu_text_10002: "Tiktok動画プロンプト",
  menu_text_10003: "翻訳",
  menu_text_10004: "画像キャプション",
  menu_text_10005: "チャット",
  menu_video: "動画",
  menu_video_20001: "テンプレート",
  menu_video_20002: "カスタムテンプレート",
  menu_video_20003: "デジタルヒューマン",
  menu_video_20004: "スタイル変換",
  menu_video_20005: "テキストから動画",
  menu_audio: "オーディオ",
  menu_audio_30001: "TTS",
  menu_audio_30002: "音声をテキストに変換",
  menu_audio_30003: "ボーカル分離",
  menu_image: "画像",
  menu_image_40001: "テキストから画像",
  menu_image_40002: "テキストから画像(flux)",
  menu_image_40003: "テキストから画像(SD3)",

  // コマンド設定ファイル
  command_clean_desc: "現在のダイアログをクリア",
  command_content_desc: "フィールド型コマンド、出力テキストコンテンツを構成用",
  command_mp3Upload_desc: "オーディオMP3ファイルをアップロード",
  command_mp3Upload_okMsg: "オーディオファイルが正常にアップロードされました。\n{{audio:value}}",
  command_mp3Upload_errorMsg: "オーディオファイルのアップロードに失敗しました。もう一度お試しください",
  command_mp3Upload_ext_buttonText: "オーディオMP3ファイルをアップロード",
  command_imageUpload_desc: "画像ファイルをアップロード",
  command_imageUpload_okMsg: "画像ファイルが正常にアップロードされました。\n{{image:value}}",
  command_imageUpload_errorMsg: "画像ファイルのアップロードに失敗しました。もう一度お試しください",
  command_imageUpload_ext_buttonText: "画像ファイルをアップロード",
  command_pitch_desc: "フィールド型コマンド、出力ピッチを構成用（デフォルト: 0）",
  command_pitch_okMsg: "指定したピッチ: {{value}}",
  command_pitch_errorMsg: "値のタイプまたは形式が正しくありません。数字である必要があります",
  command_empty_desc: "",
  command_empty_okMsg: "",
  command_empty_errorMsg: "",
  command_separator_desc: "区切り音声（先に/separator_uploadコマンドを実行する必要があります）",
  command_separator_okMsg: "正常に開始",
  command_separator_errorMsg: "開始に失敗しました。もう一度お試しください",
  command_speechToText_desc: "音声ファイルをアップロードして自動的にテキストに変換",
  command_speechToText_okMsg: "",
  command_speechToText_errorMsg: "",
  command_upload_a_video_ext_buttonText: "動画|画像ファイルをアップロード",
  command_upload_a_video_desc: "動画|画像をアップロード",
  command_upload_a_video_okMsg: "",
  command_upload_a_video_errorMsg: "",
  command_upload_a_audio_ext_buttonText: "オーディオファイルをアップロード",
  command_upload_a_audio_desc: "オーディオをアップロード",
  command_upload_a_audio_okMsg: "",
  command_upload_a_audio_errorMsg: "",
  command_set_prompt_desc: "プロンプトを設定（中国語で）",
  command_set_prompt_okMsg: "",
  command_set_prompt_errorMsg: "",
  command_digital_human_desc: "生成",
  command_digital_human_okMsg: "生成を開始",
  command_digital_human_errorMsg: "失敗",
  command_txt_2_video_desc: "生成",
  command_txt_2_video_okMsg: "生成を開始",
  command_txt_2_video_errorMsg: "失敗",
  command_speaker_desc: "フィールド型コマンド、音色選択用のドロップダウン",
  command_speaker_okMsg: "指定した音色:",
  command_choose_style_okMsg: "指定したスタイル:",
  command_language_okMsg: "指定した言語:",
  command_speed_desc: "フィールド型コマンド、速度を構成用（デフォルト: 1）",
  command_speed_okMsg: "指定した速度: {{value}}",
  command_speed_errorMsg: "値のタイプまたは形式が正しくありません。数字である必要があります",
  command_tts_desc: "音声を生成（先に/speakerと/contentコマンドを実行する必要があります）",
  command_tts_okMsg: "AIオーディオ出力:\n{{audioBlob}}",
  command_tts_errorMsg: "AIオーディオ出力失敗",
  command_volume_desc: "フィールド型コマンド、出力ボリュームを構成用（デフォルト: 1）",
  command_volume_okMsg: "指定したボリューム: {{value}}",
  command_volume_errorMsg: "値のタイプまたは形式が正しくありません。数字である必要があります！",

  command_separatorUpload_desc: "MP3ファイルをアップロード",
  command_separatorUpload_okMsg: "ファイルが正常にアップロードされました\n{{audio:value}}",
  command_separatorUpload_errorMsg: "リソースファイルのアップロードに失敗しました。もう一度お試しください",
  command_separatorUpload_ext_buttonText: "MP3リソースファイルをアップロード",

  // ページリンク
  page_link_aboutUs: "会社概要",
  page_link_privacyPolicy: "プライバシーポリシー",

}